const tabClass = (active) =>
  `rounded-lg px-3 py-2 text-[13px] font-semibold transition-colors ${
    active
      ? 'bg-eorig-navy-600 text-white'
      : 'border border-eorig-border bg-white text-eorig-ink hover:bg-eorig-surface'
  }`;

export function UploadChannelTabs({ channels, activeChannel, onChange, disabled }) {
  if (!channels?.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label="Upload channel">
      {channels.map((item) => {
        const id = item.channel;
        const active = id === activeChannel;
        const off = !item.enabled;
        const inboxBlocked =
          (id === 'SFTP' || id === 'FILE_SHARE') && item.enabled && !item.inbox_ready;
        const title = off
          ? `${item.label} is not configured in this environment`
          : inboxBlocked
            ? `Inbox folder not provisioned yet (${item.inbox_path || 'missing'})`
            : item.description;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled || off}
            title={title}
            className={`${tabClass(active)} disabled:cursor-not-allowed disabled:opacity-45`}
            onClick={() => onChange(id)}
          >
            {item.label}
            {inboxBlocked ? ' (setup needed)' : null}
          </button>
        );
      })}
    </div>
  );
}
